export const COMPANY = {
  name: "I Do Handmade Ltd",
  number: "13956070",
  address: "61 Bridge Street, Kington, Herefordshire, HR5 3DJ",
  email: "the.ackerman.family@icloud.com",
  updated: "8 October 2026",
};
